import classnames from 'classnames';
import { SfaPenaltyDot } from '../../atoms/sfa-penalty-dot';
import { SfaPenaltiesStripProps } from './sfaPenaltiesStrip.types';
import styles from './sfaPenaltiesStrip.module.scss';

const SfaPenaltiesStrip = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-penalties-strip',
  home,
  away,
  separator = 'Penalties',
  homeScore,
  awayScore,
}: SfaPenaltiesStripProps) => (
  <div
    {...nativeProps}
    data-testid={testId}
    className={classnames(styles.sfaPenaltiesStrip, classNames)}
  >
    {/* Home: [dots ●●●●●○] [10] */}
    <div className={styles.team}>
      <div className={styles.dots}>
        {home.map((result, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <SfaPenaltyDot key={`home-${idx}-${result}`} result={result} />
        ))}
      </div>
      {homeScore !== undefined ? (
        <span className={styles.score}>{homeScore}</span>
      ) : null}
    </div>

    <span className={styles.separator}>{separator}</span>

    {/* Away: [11] [●●●●● dots] */}
    <div className={styles.team}>
      {awayScore !== undefined ? (
        <span className={styles.score}>{awayScore}</span>
      ) : null}
      <div className={styles.dots}>
        {away.map((result, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <SfaPenaltyDot key={`away-${idx}-${result}`} result={result} />
        ))}
      </div>
    </div>
  </div>
);

export default SfaPenaltiesStrip;
